import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import HRule from '../../atoms/HRule'
import LogoTitle from '../../molecules/LogoTitle'
import TextCallout from '../../molecules/TextCallout'
import ScorePinCodeTemplate from '../../templates/ScorePinCodeTemplate'
import medias from '../../../util/medias'
import { FLOW_TYPES } from '../../../util/global.consts'
import { TipsBox } from '../../organisms/TipsBox'

const ContentWrapper = styled(View)`
  padding: 24px 16px;
  ${medias.desktop`
    padding: 24px 56px;
  `}

  ${({ modalMode }) => modalMode && `padding: 0 !important;`}
`

const HRuleWrapper = styled(View)`
  margin-top: 24px;
  margin-right: 0;
  margin-bottom: 24px;
  margin-left: 0;
`

const Title = styled.span.attrs({ className: 'typo-body-large' })`
  text-align: center;
  font-size: 24px;
`

export const ScorePinCodePage = ({ token, email, flow, onSuccess, onSwitchEmail, modalMode }) => (
  <ContentWrapper modalMode={modalMode}>
    <LogoTitle
      title={
        flow === FLOW_TYPES.SELF_SERVICE ? (
          <>
            <span className="typo-body-large inline">Antes de continuar, </span>
            <span className="typo-body-large inline font-bold">
              precisamos confirmar que é você.
            </span>
          </>
        ) : (
          <>
            <Title>Vamos deixar sua</Title>
            <Title className="font-semibold">conta mais segura</Title>
          </>
        )
      }
    />
    <ScorePinCodeTemplate
      token={token}
      email={email}
      flow={flow}
      onSuccess={onSuccess}
      onSwitchEmail={onSwitchEmail}
    />
    {!modalMode && flow !== FLOW_TYPES.SELF_SERVICE && (
      <>
        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>
        <TextCallout
          text=""
          linkText="Escolher outra opção para entrar"
          href="/acesso"
          onClick={onSwitchEmail}
        />
        <TipsBox />
      </>
    )}
  </ContentWrapper>
)

ScorePinCodePage.propTypes = {
  token: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  flow: PropTypes.string,
  onSuccess: PropTypes.func,
  onSwitchEmail: PropTypes.func,
  modalMode: PropTypes.bool,
}
